import { render } from "./BaseChartLegend.vue?vue&type=template&id=7c90b34e&ts=true"
import script from "./BaseChartLegend.vue?vue&type=script&lang=ts"
export * from "./BaseChartLegend.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__